
import {Component, Prop, Mixins, Watch} from "vue-property-decorator";
import {MahkemeEntity} from "@/entity/MahkemeEntity";
import YargiBirimleriPicker from "@/components/pickers/YargiBirimleriPicker.vue";
import IlamTuruPicker from "@/components/pickers/IlamTuruPicker.vue";
import DosyaTuruPicker from "@/components/pickers/DosyaTuruPicker.vue";
import SehirPicker from "@/components/pickers/SehirPicker.vue";
import AdliyePicker from "@/components/pickers/AdliyePicker.vue";
import MahkemePicker from "@/components/pickers/MahkemePicker.vue";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import {
  MahkemeHiyerarsisi,
  MahkemeUstAlani,
  mahkemeHiyerarsisiOlustur,
  temizlenecekAltAlanlar,
} from "@/utils/mahkemeSecim";

@Component({
  components: {
    SehirPicker,
    AdliyePicker,
    YargiBirimleriPicker,
    IlamTuruPicker,
    DosyaTuruPicker,
    MahkemePicker,
    FormWrapper,
  },
})
export default class MahkemeForm extends Mixins(ObjectInputMixin) {
  localValue!: MahkemeFormValue;
  @Prop() alacakBilgisi!: any;
  /**
   * DEV-2261: hâlihazırda seçili mahkeme (ilişkileriyle). MahkemeSecim formu her açılışta
   * yeniden kurduğu için alanlar burada, ilk render'dan önce bir kez doldurulur; kullanıcı
   * hiyerarşiyi baştan seçmek yerine yalnız değiştirmek istediği kırılımı değiştirir.
   * Doldurulan alanları çağıran formun varsayılanları (setDefaultValues) ezmez.
   */
  @Prop({default: null}) seciliMahkeme!: MahkemeEntity | null;

  created() {
    const hiyerarsi = mahkemeHiyerarsisiOlustur(this.seciliMahkeme);
    if (hiyerarsi)
      this.localValue = Object.assign({}, this.localValue, hiyerarsi);
  }

  @Watch('localValue.ilam')
  onIlamDegisti(yeni: any, eski: any) {
    this.altAlanlariTemizle('ilam', yeni, eski);
  }

  @Watch('localValue.yargiBirimi')
  onYargiBirimiDegisti(yeni: any, eski: any) {
    this.altAlanlariTemizle('yargiBirimi', yeni, eski);
  }

  @Watch('localValue.sehir')
  onSehirDegisti(yeni: any, eski: any) {
    this.altAlanlariTemizle('sehir', yeni, eski);
  }

  @Watch('localValue.adliye')
  onAdliyeDegisti(yeni: any, eski: any) {
    this.altAlanlariTemizle('adliye', yeni, eski);
  }

  /**
   * Üst kırılım değişince ona bağlı listeler yenilenir ve eski alt seçimler geçersiz kalır.
   * Temizlenmezse picker boş görünürken model eski mahkemeyi tutmaya devam ediyordu.
   *
   * Olaylara değil değer karşılaştırmasına bağlı: SehirPicker seçimini programatik olarak da
   * yayınlıyor ve liste yanıtları her sırada gelebiliyor; ön doldurma bunların hiçbirinde silinmez.
   */
  private altAlanlariTemizle(alan: MahkemeUstAlani, yeni: any, eski: any) {
    temizlenecekAltAlanlar(alan, yeni, eski)
        .forEach((altAlan) => this.$set(this.localValue, altAlan, null));
  }

  /**
   * DEV-2770: burada eskiden secilen mahkemenin aktif_mi bayragi 1 yapilip
   * PUT /api/v1/mahkeme/{id} ile ortak icraproweb tablosuna yaziliyordu;
   * bir buronun secimi butun burolara gidiyordu. Yazma ucu kaldirildi.
   *
   * Kullanici akisi degismedi: MahkemePicker'i besleyen
   * GET /api/v1/mahkeme/filter aktif parametresi gondermedigi icin mahkeme
   * zaten listede geliyordu; bayrak hicbir okuma yolunu acmiyordu.
   */
  onItemActivated() {
    this.$emit("onSuccess", this.localValue);
  }

  onClose() {
    this.$emit("onClose");
  }
}

interface MahkemeFormValue extends MahkemeHiyerarsisi {
  // Bazı sihirbazların varsayılanlarıyla gelir; formda alanı yok.
  dosya?: number
}
